import React from "react";
import Image from "components/image";
import SmsSignUpForm from "./form";

const SmsSubscription = ({ data }) => (
	<div className="flex gap-6 md:gap-12 flex-col-reverse md:flex-row">
		<div className="flex flex-col md:w-1/2 md:py-10">
			<SmsSignUpForm data={data} />
		</div>
		<Image className="h-52 md:h-auto md:w-1/2" image={data.image} />		
	</div>
);

export default SmsSubscription;

